/* @ngInject */
export default function ($scope, AuthService, $state, $stateParams, $window, toastr, LayoutService) {
	LayoutService.reset();
	LayoutService.setTitle('Set Password');

	$scope.user = AuthService.getUser();

	$scope.password        = '';
	$scope.confirmPassword = '';

	$scope.setPassword = () => {
		if ($scope.validate()) {
			let credentials = {
				password: $scope.password,
			};

			AuthService
				.setPassword(credentials)
				.then((user) => {
						toastr.clear();
						toastr.success('Your password was set successfully.');

						if ($stateParams.r) {
							$window.location.href = $stateParams.r;
						} else {
							$state.go('splash.home');
						}
					},
					() => {
						toastr.clear();
						toastr.error('There was an error while setting your password, please try again.', 'Error');
					},
					() => {
						toastr.clear();
						toastr.info('Loading your account information now...', 'Your password was set successfully.');
					},
				)
				.catch();
		}

		return false;
	};

	$scope.validate = () => {
		if ($scope.password == '') {
			toastr.clear();
			toastr.warning('You must provide your Password.', 'Error');

			return false;
		}

		if ($scope.confirmPassword !== $scope.password) {
			toastr.clear();
			toastr.warning('Your passwords must match.', 'Error');

			return false;
		}

		return true;
	};
};


// WEBPACK FOOTER //
// ./src/js/endpoints/auth/setPassword/controller.js